import { render, staticRenderFns } from "./CEPs.vue?vue&type=template&id=66b6b4d5&"
import script from "./CEPs.vue?vue&type=script&lang=ts&"
export * from "./CEPs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports